<template>
  <div>
    <Modal width="600"
           v-model="_value"
           :title="titleDisplay"
           @on-visible-change="visibleChange"
           @on-ok="photoRecordModal_ok"
           ok-text="关闭"
           cancel-text="">
      <div v-if="pictureRecords[currentPictureIndex]" style="text-align: center">
        <label v-if="pictureRecords[currentPictureIndex].picType === 1">【合格证】</label>
        <label v-if="pictureRecords[currentPictureIndex].picType === 2">【登记证1】</label>
        <label v-if="pictureRecords[currentPictureIndex].picType === 3">【登记证2】</label>
        <label v-if="pictureRecords[currentPictureIndex].picType === 4">【行驶证】</label>
        <label v-if="pictureRecords[currentPictureIndex].picType === 5">【车身照】</label>
        <label v-if="pictureRecords[currentPictureIndex].picType === 6">【货运转网合同】</label>
        <label v-if="pictureRecords[currentPictureIndex].picType === 7">【货运转网授权书】</label>
        <label v-if="pictureRecords[currentPictureIndex].picType === 8">【身份识别证件】</label>
        <label v-if="pictureRecords[currentPictureIndex].picType === 11">【身份识别证件背面】</label>
        <label v-if="pictureRecords[currentPictureIndex].picType === 9">【行驶证副页】</label>
        <label v-if="pictureRecords[currentPictureIndex].picType === 10">【交通局转网授权书】</label>
        <label v-if="pictureRecords[currentPictureIndex].picType === 12">【道路运输许可证】</label>
        <label v-if="pictureRecords[currentPictureIndex].picType === 13">【营业执照】</label>
        <label v-if="pictureRecords[currentPictureIndex].picType === 14">【安装证明】</label>
        <label v-if="pictureRecords[currentPictureIndex].picType === 15">【从业资格证】</label>
        <label v-if="pictureRecords[currentPictureIndex].picType === 16">【车辆交强险单据】</label>
        <label v-if="pictureRecords[currentPictureIndex].picType === 17">【车辆商业险单据】</label>
        {{pictureRecords[currentPictureIndex].key }}
        <a @click="onDownloadClick">【下载图片】</a>
      </div>
      <Carousel v-model="currentPictureIndex" v-if="_value" style="text-align: center;">
        <CarouselItem v-for="item in pictureRecords">
          <div class="demo-carousel">
            <img @click="onPhotoClick"
                 :src="'https://pic.jianchengjt.com/' + item.picKey + '?imageMogr2/thumbnail/600x400'"></img>
          </div>
        </CarouselItem>
      </Carousel>
      <div style="position:relative;">
        <Table border highlight-row size="small" @on-row-click="onRowClick" height="600" :columns="columns" :data="pictureRecords"
               :height="tableHeight" ref="table"></Table>
        <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoading">
          <Spin size="large"></Spin>
          <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
        </div>
      </div>

      <div style="margin-top: 20px;">图片上传</div>
      <div>
        <Select v-model="addPictureRecord.picType">
          <Option v-for="item in picTypeList" :value="item.val" :key="item.val">{{item.name}}</Option>
        </Select>
        <Upload
          :before-upload="handleBeforeUpload"
          action="https://upload-z2.qiniup.com">
          <Button type="default" icon="ios-cloud-upload-outline">选择上传图片</Button>
        </Upload>
        <div v-if="uploadFile !== null">上传文件: {{uploadFile.name}}
          <Button type="text" @click="upload" :loading="loadingStatus">{{loadingStatus?'正在上传':'点击上传文件'}}
          </Button>
        </div>
      </div>
    </Modal>

    <!--<Modal title="图片展示" v-model="visible">-->
    <!--<img :src="'https://o5wwk8baw.qnssl.com/' + imgName + '/large'" v-if="visible" style="width: 100%"></img>-->
    <!--</Modal>-->
  </div>

</template>

<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import axios from 'axios'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'VehiclePictureModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null
  },
  data () {
    return {
      currentPictureIndex: 0,

      titleDisplay: '图片管理',

      installOrder: {
        id: null,
        tempVehicleInfo: {
          id: null,
          customName: null,
          vin: null,
          registrationNum: null,
          registrationColor: null,
          vehicleBodyPictureId: null,
          vehicleBodyPicture: null,
          vehicleSrcLicensePicture2Id: null,
          vehicleSrcLicensePicture2: null,
          vehicleSrcLicensePicture1Id: null,
          vehicleSrcLicensePicture1: null,
          certificatePictureId: null,
          certificatePicture: null,
          vehicleLicensePictureId: null,
          vehicleLicensePicture: null,
          vehicleLicenseFlapPictureId: null,
          vehicleLicenseFlapPicture: null,
          qghyptChangeContractPictureId: null,
          qghyptChangeContractPicture: null,
          qghyptChangeAuthorizationPictureId: null,
          qghyptChangeAuthorizationPicture: null,
          idFilePictureId: null,
          idFilePicture: null,
          idFileBackPictureId: null,
          idFileBackPicture: null,
          jtjChangeAuthorizationPictureId: null,
          jtjChangeAuthorizationPicture: null,
          roadTransportationPermitCardPictureId: null,
          roadTransportationPermitCardPicture: null,
          businessLicensePictureId: null,
          businessLicensePicture: null,
          installationCertificatePictureId: null,
          installationCertificatePicture: null,
          qualificationCertificatePictureId: null,
          qualificationCertificatePicture: null,
          mandatoryLiabilityInsuranceForTrafficAccidentsPictureId: null,
          mandatoryLiabilityInsuranceForTrafficAccidentsPicture: null,
          commercialInsurancePictureId: null,
          commercialInsurancePicture: null,
        }
      },

      tableHeight: 160,
      listLoading: false,
      loadingStatus: false,
      pictureRecords: [],
      columns: [
        {
          title: 'picKey',
          key: 'picKey',
          ellipsis: 'true',
          minWidth: 250
        },
        {
          title: '图片类型',
          key: 'picType',
          ellipsis: 'true',
          minWidth: 100,
          render: (h, params) => {
            return h('Select', {
              style: { width: '80px' },
              props: {
                // value: this.data[params.index].volumeType,
                value: params.row.picType,
                disabled: !params.row.modify
              },
              on: {
                'on-change': (event) => {
                  params.row.picType = event
                  console.log(params.row.picType)
                }
              }
            },
            [
              h('Option', {
                props: {
                  value: 1
                }
              }, '合格证'),
              h('Option', {
                props: {
                  value: 2
                }
              }, '登记证1'),
              h('Option', {
                props: {
                  value: 3
                }
              }, '登记证2'),
              h('Option', {
                props: {
                  value: 4
                }
              }, '行驶证'),
              h('Option', {
                props: {
                  value: 9
                }
              }, '行驶证副页'),
              h('Option', {
                props: {
                  value: 5
                }
              }, '车身照'),
              h('Option', {
                props: {
                  value: 6
                }
              }, '货运转网合同'),
              h('Option', {
                props: {
                  value: 7
                }
              }, '货运转网授权书'),
              h('Option', {
                props: {
                  value: 8
                }
              }, '身份识别证件'),
              h('Option', {
                props: {
                  value: 11
                }
              }, '身份识别证件背面'),
              h('Option', {
                props: {
                  value: 10
                }
              }, '交通局转网授权书'),
              h('Option', {
                props: {
                  value: 12
                }
              }, '道路运输许可证'),
              h('Option', {
                props: {
                  value: 13
                }
              }, '营业执照'),
              h('Option', {
                props: {
                  value: 14
                }
              }, '安装证明'),
              h('Option', {
                props: {
                  value: 15
                }
              }, '从业资格证'),
              h('Option', {
                props: {
                  value: 16
                }
              }, '车辆交强险单据'),
              h('Option', {
                props: {
                  value: 17
                }
              }, '车辆商业险单据'),
            ]
            )
          }
        }
        //   {
        //   title: '操作',
        //   key: 'action',
        //   align: 'center',
        //   ellipsis: 'true',
        //   minWidth: 250,
        //   render: (h, params) => {
        //     return h('div', [
        //       h('Button', {
        //         props: {
        //           shape: 'circle',
        //           type: 'error',
        //           size: 'small',
        //           disabled: false
        //         },
        //         on: {
        //           click: () => {
        //             this.onDeleteBtnClick(params.row.id)
        //           }
        //         }
        //       }, '删除')]
        //     );
        //   }
        // }
      ],
      addPictureRecord: {
        picKey: null,
        srcHeight: null,
        srcWidth: null,
        picType: 1
      },
      picTypeList: [
        { name: '合格证', val: 1 },
        { name: '登记证1', val: 2 },
        { name: '登记证2', val: 3 },
        { name: '行驶证', val: 4 },
        { name: '行驶证副页', val: 9 },
        { name: '车身照', val: 5 },
        { name: '货运转网合同', val: 6 },
        { name: '货运转网授权书', val: 7 },
        { name: '身份识别证件', val: 8 },
        { name: '身份识别证件背面', val: 11 },
        { name: '交通局转网授权书', val: 10 },
        { name: '道路运输许可证', val: 12 },
        { name: '营业执照', val: 13 },
        { name: '安装证明', val: 14 },
        { name: '从业资格证', val: 15 },
        { name: '车辆交强险单据', val: 16 },
        { name: '车辆商业险单据', val: 17 },
      ],
      postParams: {
        upload_token: null
      },
      uploadFile: null
    }
  },
  methods: {
    ...mapActions([
      'PictureServ_GetQiniuUploadToken',
      'PictureServ_AddObj',
      'PictureServ_DeleteObj',
      'InstallOrderServ_GetDetail',
      'InstallOrderServ_ChangePicture'
    ]),
    onRowClick (item, index) {
      this.currentPictureIndex = index
    },
    onDownloadClick () {
      let item = this.pictureRecords[this.currentPictureIndex]
      window.open('https://pic.jianchengjt.com/' + item.picKey + '?attname=' + item.picKey + '.jpg')
    },
    onPhotoClick () {
      let item = this.pictureRecords[this.currentPictureIndex]
      window.open('https://pic.jianchengjt.com/' + item.picKey)
    },
    onDeleteBtnClick (id) {
      // store.dispatch('PictureServ_DeleteObj', {
      //   params: {id: id},
      //   urlparams: null
      // }).then(() => {
      //   this.$Message.success('删除照片成功');
      //   store.dispatch('PictureServ_GetHousePhotos', {
      //     params: {id: this._housingResourceId},
      //     urlparams: null
      //   }).then(() => {
      //     this.pictureRecords = store.getters.get_PhotoRecord_GetHousePhotosResult;
      //   }).catch(err => {
      //     this.$Message.error(err);
      //   });
      // }).catch(err => {
      //   this.$Message.error(err);
      // });
    },
    visibleChange (val) {
      if (val) {
        this.uploadFile = null
        this.loadPhotoRecords()
      }
    },
    upload () {
      console.log('开始上传')
      let param = new FormData() // 创建form对象
      param.append('chunk', '0')// 断点传输
      param.append('chunks', '1')
      param.append('key', this.postParams.picKey)
      param.append('file', this.uploadFile, this.uploadFile.name)
      param.append('token', this.postParams.upload_token)

      let config = {
        headers: { 'Content-Type': 'multipart/form-data' },
        withCredentials: false
      }
      this.loadingStatus = true

      axios.post('https://upload-z2.qiniup.com', param, config)
        .then(response => {
          console.log(response.data)
          this.addPictureRecord.picKey = this.postParams.picKey
          store.dispatch('InstallOrderServ_ChangePicture', {
            params: {
              id: this._initValue,
              picKey: this.addPictureRecord.picKey,
              picType: this.addPictureRecord.picType,
              srcWidth: this.addPictureRecord.srcWidth,
              srcHeight: this.addPictureRecord.srcHeight
            },
            urlparams: null
          }).then(() => {
            this.loadingStatus = false
            this.$Message.success('添加图片成功')
            this.uploadFile = null
            this.loadPhotoRecords()
            this.$emit('on-success')
          }).catch(err => {
            this.loadingStatus = false
            this.$Message.error(err)
          })
        }).catch(err1 => {
          this.$Message.error(err1)
          this.loadingStatus = false
        })
    },
    photoRecordModal_ok () {

    },
    handleView (name) {
      this.imgName = name
      this.visible = true
    },
    handleRemove (file) {
      const fileList = this.$refs.upload.fileList
      this.$refs.upload.fileList.splice(fileList.indexOf(file), 1)
    },
    handleSuccess (res, file) {
      file.url = 'https://o5wwk8baw.qnssl.com/7eb99afb9d5f317c912f08b5212fd69a/avatar'
      file.name = '7eb99afb9d5f317c912f08b5212fd69a'
    },
    handleFormatError (file) {
      this.$Notice.warning({
        title: 'The file format is incorrect',
        desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.'
      })
    },
    handleMaxSize (file) {
      this.$Notice.warning({
        title: 'Exceeding file size limit',
        desc: 'File  ' + file.name + ' is too large, no more than 2M.'
      })
    },
    handleBeforeUpload (file) {
      console.log('handleBeforeUpload')
      store.dispatch('PictureServ_GetQiniuUploadToken', {
        params: {head: 'INSTALLORDER'},
        urlparams: null
      }).then(() => {
        this.postParams.upload_token = store.getters.get_Picture_GetQiniuUploadTokenResult.uploadToken
        this.postParams.picKey = store.getters.get_Picture_GetQiniuUploadTokenResult.photoKey
        this.uploadFile = file
        console.log('PictureServ_GetQiniuUploadToken ok')
      }).catch(err => {
        this.$Message.error(err)
      })
      return false
    },
    loadPhotoRecords () {
      store.dispatch('InstallOrderServ_GetDetail', {
        params: { id: this._initValue },
        urlparams: null
      }).then(() => {
        let title = null
        let installOrder = store.getters.get_InstallOrder_GetDetailResult
        this.installOrder = installOrder
        let vehicleInfo = this.installOrder.tempVehicleInfo
        console.log(this.installOrder)
        console.log(vehicleInfo)
        if (this.installOrder.vehicleInfoId) {
          store.dispatch('VehicleInfoServ_GetDetail', {
            params: {
              id: this.installOrder.vehicleInfoId
            }
          }).then(res => {
            if (store.getters.get_VehicleInfo_GetDetailResult) {
              if (store.getters.get_VehicleInfo_GetDetailResult.registrationNum) {
                title = store.getters.get_VehicleInfo_GetDetailResult.registrationNum
              } else if (store.getters.get_VehicleInfo_GetDetailResult.vin) {
                title = store.getters.get_VehicleInfo_GetDetailResult.vin
              }
            }
            this.titleDisplay = '安装图片管理 【' + title + '】'
          })
        } else {
          if (this.installOrder.tempVehicleInfo.registrationNum) {
            title = this.installOrder.tempVehicleInfo.registrationNum
          } else if (this.installOrder.tempVehicleInfo.vin) {
            title = this.installOrder.tempVehicleInfo.vin
          }
        this.titleDisplay = '图片管理 【' + title + '】'
        }
        this.pictureRecords = []
        if (vehicleInfo.vehicleBodyPicture) {
          this.pictureRecords.push(vehicleInfo.vehicleBodyPicture)
        }
        if (vehicleInfo.vehicleSrcLicensePicture2) {
          this.pictureRecords.push(vehicleInfo.vehicleSrcLicensePicture2)
        }
        if (vehicleInfo.vehicleSrcLicensePicture1) {
          this.pictureRecords.push(vehicleInfo.vehicleSrcLicensePicture1)
        }
        if (vehicleInfo.certificatePicture) {
          this.pictureRecords.push(vehicleInfo.certificatePicture)
        }
        if (vehicleInfo.vehicleLicensePicture) {
          this.pictureRecords.push(vehicleInfo.vehicleLicensePicture)
        }
        if (vehicleInfo.qghyptChangeContractPicture) {
          this.pictureRecords.push(vehicleInfo.qghyptChangeContractPicture)
        }
        if (vehicleInfo.qghyptChangeAuthorizationPicture) {
          this.pictureRecords.push(vehicleInfo.qghyptChangeAuthorizationPicture)
        }
        if (vehicleInfo.idFilePicture) {
          this.pictureRecords.push(vehicleInfo.idFilePicture)
        }
        if (vehicleInfo.vehicleLicenseFlapPicture) {
          this.pictureRecords.push(vehicleInfo.vehicleLicenseFlapPicture)
        }
        if (vehicleInfo.jtjChangeAuthorizationPicture) {
          this.pictureRecords.push(vehicleInfo.jtjChangeAuthorizationPicture)
        }
        if (vehicleInfo.idFileBackPicture) {
          this.pictureRecords.push(vehicleInfo.idFileBackPicture)
        }
        if (vehicleInfo.roadTransportationPermitCardPicture) {
          this.pictureRecords.push(vehicleInfo.roadTransportationPermitCardPicture)
        }
        if (vehicleInfo.businessLicensePicture) {
          this.pictureRecords.push(vehicleInfo.businessLicensePicture)
        }
        if (vehicleInfo.installationCertificatePicture) {
          this.pictureRecords.push(vehicleInfo.installationCertificatePicture)
        }
        if (vehicleInfo.qualificationCertificatePicture) {
          this.pictureRecords.push(vehicleInfo.qualificationCertificatePicture)
        }
        if (vehicleInfo.mandatoryLiabilityInsuranceForTrafficAccidentsPicture) {
          this.pictureRecords.push(vehicleInfo.mandatoryLiabilityInsuranceForTrafficAccidentsPicture)
        }
        if (vehicleInfo.commercialInsurancePicture) {
          this.pictureRecords.push(vehicleInfo.commercialInsurancePicture)
        }
        this.pictureRecords.forEach(item => {
          Vue.set(item, 'modify', false)
        })
      }).catch(err => {
        this.$Message.error(err)
      })
    }
  },
  mounted () {
    // this.uploadList = this.$refs.upload.fileList;
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  }
}
</script>

<style scoped>
  .demo-upload-list {
    display: inline-block;
    width: 120px;
    height: 120px;
    text-align: center;
    line-height: 120px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
    margin-right: 4px;
  }

  .demo-upload-list img {
    width: 100%;
    height: 100%;
  }

  .demo-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, .6);
  }

  .demo-upload-list:hover .demo-upload-list-cover {
    display: block;
  }

  .demo-upload-list-cover i {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }

  .demo-carousel {
    height: 400px;
    width: 600px;
    /*line-height: 200px;*/
    text-align: center;
    color: #fff;
    font-size: 20px;
    background-color: #506b9e;
  }

  .demo-carousel img {
    height: 400px;
    width: 600px;
  }
</style>
